export var DEFAULT_SAMPLES = 20;
export var setDefaultSamples = function setDefaultSamples(n) {
  return DEFAULT_SAMPLES = n;
};